import { ApplicationConfig, ErrorHandler } from "@angular/core"
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http"
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async"
import { provideRouter, withComponentInputBinding } from "@angular/router"
import { AuthInterceptor } from "app/factories/auth_inteceptor"
import { tvAppRoutes } from "app/app-routing.module"
import { BugsnagErrorHandler } from "@bugsnag/plugin-angular"

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: ErrorHandler, useFactory: () => { return new BugsnagErrorHandler(); } },
    provideAnimationsAsync(), //BrowserAnimationModule
    provideRouter(tvAppRoutes, withComponentInputBinding()),
    provideHttpClient(withInterceptorsFromDi())
    // Not currently using serviceworker as it 401's requests on ChromeCasts
  ]
}
